define('plugin/client-login/view/ClientLoginInfoModuleView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    return LayoutView.extend({

        template: '#client_login_module_info',
        modelEvents: {
            'sync': 'render'
        }

    });

});
